import type { ReactNode } from 'react';
import { clsx } from '../../../ds/clsx';
import styles from './RoomHeader.module.css';

/**
 * Head row of the dark room: Beratung 10 (eyebrow „DAMOKLES Meetingraum", title, time pill, deal line) and
 * Beratung 11/12 (recording pill, title, consent/share pill, deal line or share note).
 */
export function RoomHeader({
  variant,
  children,
  end,
}: {
  variant: 'lobby' | 'call';
  children: ReactNode;
  end?: ReactNode;
}) {
  return (
    <header className={clsx(styles.header, variant === 'lobby' ? styles.lobby : styles.call)}>
      {children}
      {end ? <span className={clsx(styles.end, variant === 'call' && styles.endMuted)}>{end}</span> : null}
    </header>
  );
}

export function HeaderEyebrow({ children }: { children: ReactNode }) {
  return <span className={styles.eyebrow}>{children}</span>;
}

/** Display title (lobby, 16 px) or the plain title of the call head (12 px). */
export function HeaderTitle({ children, plain = false }: { children: ReactNode; plain?: boolean }) {
  return <h1 className={plain ? styles.plainTitle : styles.title}>{children}</h1>;
}

/** Glass pill („Mi 16.09. · 10:00 – 10:45", „Einwilligung vollständig · 2 Teilnehmende"). */
export function HeaderPill({ children, tone = 'glass' }: { children: ReactNode; tone?: 'glass' | 'share' }) {
  return <span className={clsx(styles.pill, tone === 'share' && styles.sharePill)}>{children}</span>;
}
